/*eslint-disable*/
import React from "react";
// @material-ui/core components

import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
// import Icon from "@material-ui/core/Icon";

// core components
import Footer from "components/GFooter/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Input from "components/GCustomInput/CustomInput.js";

/**
 * Register style
 */
import styles from "assets/jss/material-kit-pro-react/views/gRegisterStyle.js";

import image from "assets/img/newbg1.jpg";

import { withRouter } from "react-router-dom";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

/**
 * Alert Snackbar
 */
import SnackbarContent from "components/GSnackbar/SnackbarContent.js";

//libs
import { Redirect } from "react-router-dom";
import axios from "axios";
import Config from "config";

import Zoom from "@material-ui/core/Zoom";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import Brightness1 from "@material-ui/icons/Brightness1";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

import { LinearProgress, Typography, Box } from "@material-ui/core";

import zxcvbn from "zxcvbn";
import secureStorage from "libs/secureStorage";

const style = (theme) => ({
  ...styles,
  buttons: {
    marginTop: "25px",
  },
  progress: {
    height: 10,
    borderRadius: 5,
  },
  error: {
    backgroundColor: "#f44336", // red
  },
  warning: {
    backgroundColor: "#ff9800", // orange/yellow
  },
  success: {
    backgroundColor: "#4caf50", // green
  },
  inlineRule: {
    display: "inline-flex",
    alignItems: "center",
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  valid: {
    color: "green",
  },
  invalid: {
    color: "red",
  },
  icon: {
    fontSize: 18,
    marginRight: 4,
  },
});
/**
 * Transition for Modal
 */
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom ref={ref} {...props} />;
});

const rules = [
  { label: "Min. 10 karakter" },
  { label: "Huruf besar" },
  { label: "Huruf kecil" },
  { label: "Angka" },
  { label: "Simbol (@#$!)" },
];

class PasswordExpired extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      password: "",
      repassword: "",
      alert: false,
      error: [],
      success: [],

      redirect: false,

      showModal: false,
      modalTitle: "",
      modalMessage: "",
      confirmationStatus: 1,

      loggIn: true,

      score: 0,
      progressValue: 0,
      strengthText: ["Very Weak", "Weak", "Fair", "Good", "Strong"],
      buttonDisabled: true,
    };
  }

  getBarColor = (classes) => {
    if (this.state.score <= 1) return classes.error;
    if (this.state.score <= 3) return classes.warning;
    return classes.success;
  };

  handleChange = (e) => {
    if (e.target.id === "password") {
      const score = zxcvbn(e.target.value).score;
      const progressValue = ((score + 1) / 5) * 10;

      this.setState({
        password: e.target.value,
        score,
        progressValue,
        buttonDisabled: score === 4 ? false : true,
      });
    } else if (e.target.id === "repassword") {
      this.setState({ repassword: e.target.value });
    }
  };

  handleBlur = (e) => {
    if (e.target.value) {
      switch (e.target.id) {
        default:
          this.setState({
            error: { ...this.state.error, [e.target.id]: false },
            success: { ...this.state.success, [e.target.id]: true },
          });
      }
    } else {
      this.setState({
        success: { ...this.state.success, [e.target.id]: false },
        error: { ...this.state.error, [e.target.id]: true },
      });
    }
  };

  handleKeydown = (e) => {
    if (e.key === "Enter") this.save();
  };

  handleModal = (e) => {
    this.setState({ showModal: false, buttonDisabled: false });

    if (this.state.confirmationStatus === 2) {
      let account = secureStorage.getItem("account");
      account.isPasswordExpired = false;
      secureStorage.setItem("account", account);
      window.location.href = "/";
    }

    if (this.state.confirmationStatus === 3) {
      secureStorage.removeItem("token");
      secureStorage.removeItem("account");
      this.setState({ loggIn: false });
    }
  };

  handleSave = (e) => {
    this.save();
  };

  save = () => {
    // console.log({
    //   password: this.state.password,
    //   repassword: this.state.repassword,
    // });
    if (!this.state.password) {
      this.setState({
        modalMessage: "New Password can not be empty",
        showModal: true,
        confirmationStatus: 1,
      });
    } else if (this.state.password !== this.state.repassword) {
      this.setState({
        modalMessage: "Re-type New Password did not match",
        showModal: true,
        confirmationStatus: 1,
      });
    } else {
      this.setState({ buttonDisabled: true });
      const account = secureStorage.getItem("account");
      const token = secureStorage.getItem("token");
      const payload = {
        password: this.state.password,
      };

      const url =
        account.LoginUsers && account.LoginUsers.length > 0
          ? "user/ChangePasswordExpired/lu"
          : "user/ChangePasswordExpired";
      const endpoint = `${Config.backendUrl}${url}`;

      axios
        .post(endpoint, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // optional but recommended
          },
        })
        .then((res) => {
          this.setState({
            modalMessage: "Password has been changed",
            showModal: true,
            confirmationStatus: 2,
            password: "",
            repassword: "",
            buttonDisabled: false,
          });
        })
        .catch((err) => {
          if (err.response) {
            this.setState({
              modalMessage:
                err.response.data === "Forbidden Access"
                  ? "Ganti password gagal karena session anda telah habis, Silahkan lakukan login ulang"
                  : err.response.data,
              showModal: true,
              confirmationStatus:
                err.response.data === "Forbidden Access" ? 3 : 1,
              buttonDisabled: false,
            });
          } else {
            this.setState({
              modalMessage: "Connection problem",
              showModal: true,
              confirmationStatus: 1,
              buttonDisabled: false,
            });
          }
        });
    }
  };

  render() {
    if (!this.state.loggIn) {
      return <Redirect to="/login" />;
    }
    const { classes } = this.props;

    return (
      <div>
        <div
          className={classes.pageHeader}
          style={{
            backgroundImage: "url(" + image + ")",
            backgroundSize: "cover",
            backgroundPosition: "top center",
          }}
        >
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={9} sm={9} md={9}>
                <Card className={classes.cardSignup}>
                  <center>
                    <h2 className={classes.cardTitle}>
                      Password telah kadaluarsa, Silahkan ganti password anda!
                    </h2>
                  </center>
                  <CardBody>
                    <GridContainer justify="center">
                      <GridItem xs={8} sm={8} md={8}>
                        <form className={classes.form}>
                          <Input
                            error={
                              this.state.error
                                ? this.state.error.password
                                : false
                            }
                            success={
                              this.state.success
                                ? this.state.success.password
                                : false
                            }
                            id="password"
                            formControlProps={{
                              fullWidth: true,
                              className: classes.customFormControlClasses,
                            }}
                            inputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() =>
                                      this.setState({
                                        showPassword: !this.state.showPassword,
                                      })
                                    }
                                  >
                                    {this.state.showPassword ? (
                                      <VisibilityOffIcon />
                                    ) : (
                                      <VisibilityIcon />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                              type: this.state.showPassword
                                ? "text"
                                : "password",
                              placeholder: "Password...",
                              onChange: this.handleChange,
                              onBlur: this.handleBlur,
                            }}
                            labelText="Password"
                          />
                          <Box mt={2}>
                            <Typography variant="subtitle2" gutterBottom>
                              Aturan Password:
                            </Typography>
                            <Box display="flex" flexWrap="wrap">
                              {rules.map((rule, index) => {
                                return (
                                  <Box
                                    key={index}
                                    className={classes.inlineRule}
                                  >
                                    <Brightness1
                                      className={`${classes.icon}`}
                                    />
                                    <Typography variant="body2">
                                      {rule.label}
                                    </Typography>
                                  </Box>
                                );
                              })}
                            </Box>
                          </Box>

                          {this.state.password && (
                            <>
                              <Box mt={2}>
                                <LinearProgress
                                  variant="determinate"
                                  value={this.state.progressValue * 10}
                                  classes={{
                                    root: classes.progress,
                                    barColorPrimary: this.getBarColor(classes),
                                  }}
                                  color="primary"
                                />
                              </Box>
                              <Typography
                                variant="body2"
                                style={{ marginTop: 8 }}
                              >
                                Strength:{" "}
                                <strong>
                                  {this.state.strengthText[this.state.score]}
                                </strong>
                              </Typography>
                            </>
                          )}

                          {/* REPEAT PASSOWRD */}
                          <Input
                            error={
                              this.state.error
                                ? this.state.error.repassword
                                : false
                            }
                            success={
                              this.state.success
                                ? this.state.success.repassword
                                : false
                            }
                            id="repassword"
                            formControlProps={{
                              fullWidth: true,
                              className: classes.customFormControlClasses,
                            }}
                            inputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={() =>
                                      this.setState({
                                        showPassword: !this.state.showPassword,
                                      })
                                    }
                                  >
                                    {this.state.showPassword ? (
                                      <VisibilityOffIcon />
                                    ) : (
                                      <VisibilityIcon />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                              type: this.state.showPassword
                                ? "text"
                                : "password",
                              placeholder: "Re-type Password...",
                              onChange: this.handleChange,
                              onBlur: this.handleBlur,
                            }}
                            labelText="Re-Password"
                          />
                          {this.state.alert ? (
                            <SnackbarContent
                              message={<span>Semua kolom harus diisi</span>}
                              onExited={this.handleAlertExit}
                              close
                              color="danger"
                              icon="info_outline"
                            />
                          ) : null}

                          <div>
                            <div
                              className={classes.textCenter}
                              style={{ textAlign: "center" }}
                            >
                              <Button
                                round
                                color="instagram"
                                onClick={this.handleSave}
                                disabled={
                                  !this.state.error.password &&
                                  !this.state.error.repassword &&
                                  !this.state.buttonDisabled
                                    ? false
                                    : true
                                }
                              >
                                submit
                              </Button>
                            </div>
                            <Dialog
                              classes={{
                                root: classes.modalRoot,
                                paper: classes.modal,
                              }}
                              open={this.state.showModal}
                              TransitionComponent={Transition}
                              keepMounted
                              aria-labelledby="classic-modal-slide-title"
                              aria-describedby="classic-modal-slide-description"
                            >
                              <DialogTitle
                                id="classic-modal-slide-title"
                                disableTypography
                                className={classes.modalHeader}
                              >
                                <h4 className={classes.modalTitle}>
                                  {this.state.modalTitle}
                                </h4>
                              </DialogTitle>
                              <DialogContent
                                id="classic-modal-slide-description"
                                className={classes.modalBody}
                              >
                                <p>{this.state.modalMessage}</p>
                              </DialogContent>
                              <DialogActions className={classes.modalFooter}>
                                <Button
                                  round
                                  onClick={this.handleModal}
                                  color="success"
                                >
                                  OK
                                </Button>
                              </DialogActions>
                            </Dialog>
                          </div>
                        </form>
                      </GridItem>
                    </GridContainer>
                  </CardBody>
                </Card>
              </GridItem>
            </GridContainer>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

PasswordExpired.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withRouter(withStyles(style)(PasswordExpired));
